export const solutionsListing = {
  meta: {
    title: "Solutions — ConX Orbit",
    description:
      "Explore platforms, AI systems, and workflow solutions engineered for façade and construction operations.",
  },
  hero: {
    badge: "Solutions",
    titleBefore: "Solutions Built Around Real ",
    titleHighlight: "Construction",
    titleAfter: " Workflows.",
    body: "Explore the platforms, AI systems, and workflow solutions we've engineered to solve practical challenges across façade and construction operations.",
  },
  searchPlaceholder: "Search solutions...",
  cta: {
    badge: "DON'T SEE WHAT YOU NEED?",
    title: "Let's Build the Right Solution for Your Workflow",
    body: "Every construction business operates differently. Tell us about your workflows and we'll help you find—or build—the right system.",
    primary: { label: "Book a Discovery Call", href: "/book-discovery" },
  },
};
